import { toArray } from '@wix/wow-utils';
const name = 'BaseRotate3D';
const properties = {};
function animate(kit, elements, duration = 0, delay = 0, { perspective, ...params } = {}) {
    elements = toArray(elements);
    const allowedParams = ['rotationX', 'rotationY', 'rotationZ'];
    // TODO: We need to fix or css cleaning technique.
    // TODO: this setting is actually never read
    const sequence = kit.sequence();
    if (perspective) {
        sequence.add(kit.engine.set(elements, { transformPerspective: perspective }), 0);
    }
    sequence.add(kit.engine.tween(elements, { duration, delay, ...params }, allowedParams));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=baseRotate3D.js.map